import { getBrand } from './getBrand';
import * as idb from 'idb-keyval';

let customStore: idb.UseStore;

export function initializeIdbKeyval(): void {
  customStore = idb.createStore(
    getBrand().code + '_CHAT_APP_DB',
    'keyvaluepairs'
  );
}

export async function getStoreIdb() {
  return await idb.get('store', customStore);
}

export async function setStoreInIdb(state) {
  return await idb.set('store', state, customStore);
}
